import Console from '@/shared/console';
/**
 * orderByMappedCategory: this function returns a shallow, reordered copy of listToOrder by category, categories ordered
 * by one of their fields
 * listToOrder: The list of items to order, can be of any type
 * accessor: A function to access the field by which you want to order
 * categories: The list of categories that the items can have
 * categoryKeyAccessor: A function to access the key of the category
 * categoryFieldAccessor: A function to access the field by which the category will be ordered
 *
 */
const orderByMappedCategory = function (listToOrder, accessor, categories, categoryKeyAccessor, categoryFieldAccessor) {
  return listToOrder.slice().sort((firstElement, secondElement) => {
    const getCategoricFieldFromItem = _getCategoricFieldFromItemGenerator(accessor, categories, categoryKeyAccessor, categoryFieldAccessor);
    const firstValueToOrderBy = getCategoricFieldFromItem(firstElement);
    const secondValueToOrderBy = getCategoricFieldFromItem(secondElement);

    const isFirstValueUndefinded = firstValueToOrderBy === undefined;
    const isSecondValueUndefinded = secondValueToOrderBy === undefined;

    // if some element doesn't have a category it goes last.
    if (isFirstValueUndefinded && isSecondValueUndefinded) {
      return 0;
    } else if (isFirstValueUndefinded) {
      return 1;
    } else if (isSecondValueUndefinded) {
      return -1;
    }

    if (typeof firstValueToOrderBy !== typeof secondValueToOrderBy) {
      // console and throw just in case someone is doing a catch without real handling as this error should prompt
      // some kind of data change
      Console.error('Tried to compare values with different types, please check the values of the category field');
      throw new Error('Tried to compare values with different types, please check the values of the category field');
    }

    if (firstValueToOrderBy > secondValueToOrderBy) {
      return 1;
    } else if (firstValueToOrderBy < secondValueToOrderBy) {
      return -1;
    } else {
      return 0;
    }
  });
};

const _getCategoricFieldFromItemGenerator = function (accessor, categories, categoryKeyAccessor, categoryFieldAccessor) {
  return function (element) {
    const value = accessor(element);
    const category = categories.find((category) => {
      return value === categoryKeyAccessor(category);
    });
    if (category) {
      return categoryFieldAccessor(category);
    } else {
      return undefined;
    }
  };
};

export default {
  orderByMappedCategory,
};
